import { BaseState } from "@/store/state";

const getters = {
  getToken: (state: BaseState): string => {
    return window.localStorage.getItem("eccipe:token") || state.token;
  },
};

export default getters;
